import { CopyButton } from '@/components/ui/CopyButton'
import { IconButton } from '@/components/ui/IconButton'
import { ProposedFormFieldValue } from '@/events/formApplyEvents'
import { memo, useCallback } from 'react'
import { useTranslations } from '@/hooks/useTranslations'

const TRUNCATE_LENGTH = 300

type FormFieldRowProps = {
  field: ProposedFormFieldValue
  isExpanded: boolean
  canApply: boolean
  onToggleExpand: (fieldName: string) => void
  onApply: (field: ProposedFormFieldValue) => void
}
export const FormFieldRow = memo(({ field, isExpanded, canApply, onToggleExpand, onApply }: FormFieldRowProps) => {
  const t = useTranslations()
  const shouldTruncate = field.value.length > TRUNCATE_LENGTH
  const displayValue = shouldTruncate && !isExpanded ? `${field.value.slice(0, TRUNCATE_LENGTH)}...` : field.value

  const handleToggle = useCallback(() => {
    onToggleExpand(field.name)
  }, [field.name, onToggleExpand])

  const handleApply = useCallback(() => {
    onApply(field)
  }, [field, onApply])

  return (
    <div className='mp-agent-form-proposal-row'>
      <div className='mp-agent-form-proposal-main'>
        <div className='mp-agent-form-proposal-label'>{field.label || field.name}</div>
        <div className='mp-agent-form-proposal-value-container'>
          <div className='mp-agent-form-proposal-value'>
            {displayValue}

            {shouldTruncate && (
              <button type='button' onClick={handleToggle} className='mp-agent-form-proposal-show-all'>
                {isExpanded ? t.formProposalShowLess : t.formProposalShowAll}
              </button>
            )}
          </div>
        </div>
      </div>
      <div className='mp-agent-form-proposal-actions-row'>
        <IconButton
          icon='Check'
          onClick={handleApply}
          tooltip={`${t.formProposalApplyFieldPrefix} ${field.label || field.name}`}
          size='sm'
        />
        {/* {canApply && <IconButton icon='Check' onClick={handleApply} tooltip={`Apply ${field.name}`} size='sm' />} */}
        <CopyButton text={field.value} />
      </div>
    </div>
  )
})

FormFieldRow.displayName = 'FormFieldRow'
